/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'components/navigation';
import styled from '@emotion/styled';

export const StyledLi = styled('li')`
  height: 100%;
  display: inline-block;
  padding: 0 16px;
`;

export const StyledNavLink = styled(NavLink)`
  height: 100%;
  color: ${({ theme }) => theme.gray.base};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: ${({ theme }) => theme.fonts.regular};
  font-size: 14px;
  position: relative;
  transition: color 300ms ease;
  text-decoration: none;

  &.active {
    color: ${({ theme }) => theme.secondary.base};
    font-family: ${({ theme }) => theme.fonts.soehneKraftig};

    &:after {
      content: '';
      width: 100%;
      height: 4px;
      background: ${({ theme }) => theme.secondary.base};
      display: block;
      position: absolute;
      bottom: -1px;
      left: 0;
    }
  }
`;

const SectionNavItem = ({ children, to, ...props }) => (
  <StyledLi>
    <StyledNavLink partial={false} to={to} {...props}>
      {children}
    </StyledNavLink>
  </StyledLi>
);

SectionNavItem.propTypes = {
  children: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
};

SectionNavItem.displayName = 'SectionNavItem';

export default SectionNavItem;
